<div class="button-container">
  <bepatient-button
    [label]="question.label"
    [color]="isCompleted ? 'medium' : isFailed ? 'danger' : color"
    [disabled]="isCompleted || isFailed"
    (buttonClicked)="openDeeplink($event)"
  ></bepatient-button>

  <!-- Completion status text -->
  <!-- <div class="completion-status" *ngIf="isCompleted">
    <ion-text color="medium" class="completion-text">
      <ion-icon name="checkmark-circle-outline"></ion-icon>
      <small>Completed</small>
    </ion-text>
  </div> -->

  <!-- Failed status text -->
  <!-- <div class="completion-status" *ngIf="isFailed">
    <ion-text color="danger" class="completion-text">
      <ion-icon name="close-circle-outline"></ion-icon>
      <small>Failed</small>
    </ion-text>
  </div> -->
</div>
